import { render, staticRenderFns } from "./OrmUtilitiesDetail.vue?vue&type=template&id=638bbbba&scoped=true"
import script from "./OrmUtilitiesDetail.vue?vue&type=script&lang=js"
export * from "./OrmUtilitiesDetail.vue?vue&type=script&lang=js"
import style0 from "./OrmUtilitiesDetail.vue?vue&type=style&index=0&id=638bbbba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638bbbba",
  null
  
)

export default component.exports